// #region imports

// --- Angular
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

// --- RxJs
import { of } from 'rxjs';
import { delay } from 'rxjs/operators';

// --- HS Code
import {
  ParticipantValidationStages,
  ParticipantTokenValidationModel,
  ParticipantRegistrationModel,
  TokenValidationErrorTypes,
  Constants,
} from '../../../models';
import { AppService } from '../app.service';
import { ParticipantValidationBaseService } from './participantvalidation-base.service';

// #endregion

@Injectable({
  providedIn: 'root'
})
export class ParticipantValidationMockService extends ParticipantValidationBaseService {

  constructor(
    private router: Router,
    appService: AppService,
    ) {
      super(appService);
     }

    validateParticipantToken(token: string | null, destination: string | null): void {
      of(token)
      .pipe(delay(5000))
      .subscribe(result => {
        if (result === 'error') {
          this._validationStage$.next(ParticipantValidationStages.tokenError);
          this._participantValidation$.next({
            tokenValue: '',
            hasPassword: false,
            tokenValidationErrorType: TokenValidationErrorTypes.unexpectedError,
            locale: '',
            applicationError: {
              errorMessage: 'errorHeaderUnexpected',
              detailedMessage: 'participantValidationUnexpectedError'
            }
          } as ParticipantTokenValidationModel);
          return;
        }

        if (result === 'invalid') {
          this._validationStage$.next(ParticipantValidationStages.tokenError);
          this._participantValidation$.next({
            tokenValue: '',
            hasPassword: false,
            tokenValidationErrorType: TokenValidationErrorTypes.invalidToken,
            locale: '',
            applicationError: {
              errorMessage: 'errorHeaderTokenError',
              detailedMessage: 'participantValidationInvalidTokenError'
            }
          } as ParticipantTokenValidationModel);
          return;
        }

        if (result === 'used') {
          this._validationStage$.next(ParticipantValidationStages.tokenError);
          this._participantValidation$.next({
            tokenValue: '',
            hasPassword: false,
            tokenValidationErrorType: TokenValidationErrorTypes.tokenIsUsed,
            locale: '',
            applicationError: {
              errorMessage: 'errorHeaderTokenError',
              detailedMessage: 'participantValidationUsedTokenError'
            }
          } as ParticipantTokenValidationModel);
          return;
        }

        if (result === 'expired') {
          this._validationStage$.next(ParticipantValidationStages.tokenError);
          this._participantValidation$.next({
            tokenValue: '',
            hasPassword: false,
            tokenValidationErrorType: TokenValidationErrorTypes.tokenIsExpired,
            locale: '',
            applicationError: {
              errorMessage: 'errorHeaderTokenError',
              detailedMessage: 'participantValidationExpiredTokenError'
            }
          } as ParticipantTokenValidationModel);
          return;
        }

        if (result === 'haspassword') {
          this._validationStage$.next(ParticipantValidationStages.tokenValidated);
          this._participantValidation$.next({
            tokenValue: 'haspassword',
            hasPassword: true,
            tokenValidationErrorType: TokenValidationErrorTypes.noError,
            locale: '',
            applicationError: null
          } as ParticipantTokenValidationModel);
          return;
        }

        if (destination) {
          localStorage.setItem(Constants.PARTICIPANT_REDIRECT_DESTINATION_KEY, destination);
        }
        this.router.navigate(['/dashboard']);
      });
    }

    setPassword(setPasswordModel: ParticipantRegistrationModel): void {
      this._validationStage$.next(ParticipantValidationStages.settingPassword);

      of(setPasswordModel).pipe(
        delay(3000)
      )
      .subscribe(result => {
        if (result.password === 'Error123') {
          this._validationStage$.next(ParticipantValidationStages.tokenError);
          this._participantValidation$.next({
            tokenValue: '',
            hasPassword: false,
            tokenValidationErrorType: TokenValidationErrorTypes.unexpectedError,
            locale: '',
            applicationError: {
              errorMessage: 'errorHeaderPasswordError',
              detailedMessage: 'participantValidationSetPasswordError'
            }
          } as ParticipantTokenValidationModel);
          return;
        }

        this._validationStage$.next(ParticipantValidationStages.authenticating);
      });
    }
  }
